module.exports = {
      id: "register-usage",
      viewBox: "0 0 59.9 67.6",
      url: "/typo3conf/ext/samson_druck_sitepackage/Resources/Public/Theme/img/" + "sprite.svg#register",
      toString: function () {
        return this.url;
      }
    }